import React from 'react';
import Actions from './actions';
import { ActionColumn, CategoryColumn, ConsentModeColumn, LinkColumn, columns } from './columns';

export default function buildViewableDataTableProps({ canTakeActions, onRowClicked, hasConsentMvp, hasConsentMode }) {
  let tableColumns = columns;

  if (hasConsentMode) {
    tableColumns = [...tableColumns, ConsentModeColumn];
  }

  if (hasConsentMvp) {
    tableColumns = [...tableColumns, CategoryColumn];
  }

  tableColumns = [...tableColumns, LinkColumn];

  if (canTakeActions) {
    return {
      actions: <Actions />,
      columns: [...tableColumns, ActionColumn],
      pointerOnHover: true,
      onRowClicked,
    };
  }

  return {
    columns: tableColumns,
  };
}
